"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TENANT_CONTEXT = exports.CLIENT_APPLICATION = exports.ACCEPT_LANGUAGE = void 0;
const ACCEPT_LANGUAGE = exports.ACCEPT_LANGUAGE = 'accept-language';
const CLIENT_APPLICATION = exports.CLIENT_APPLICATION = 'x-client-application';
const TENANT_CONTEXT = exports.TENANT_CONTEXT = 'x-tenant-context';
//# sourceMappingURL=customHeaderNames.js.map